<script setup lang="ts">
import { en } from '@nuxt/ui/locale'
import { mi } from './utils/locales'
import { useIntervalFn } from '@vueuse/core'

const colorMode = useColorMode()
const color = computed(() => colorMode.value === 'dark' ? '#1b1718' : 'white')
const { locale } = useI18n()
const { $healthCheck } = useNuxtApp()

const INTERVAL = 5 * 60 * 1000

const {data: HealthCheckItem, pending, error, refresh} = await $healthCheck()

const { pause, resume, isActive } = useIntervalFn(async () => {
  await refresh()

  if (isDegraded) {
    //console.warn('Health check failed:', error.value)
    // Optional: Trigger a Nuxt UI toast notification here
   // const toast = useToast()
    //toast.add({ title: 'Service Degraded', color: 'error' })
  }
}, INTERVAL)


// NO IMPORT NEEDED: extendLocale is a global Nuxt UI utility auto-imported by the framework.
const currentUiLocale = computed(() => {
  if (locale.value === "mi-nz") {
    return extendLocale(mi, { code: 'mi-NZ' })
  }
  return extendLocale(en, { code: 'en-NZ' })
})

const langCode = computed(() => {
  return locale.value === "mi-nz" ? "mi-nz" : "en-nz"
})

useHead({
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    {
      key: 'theme-color',
      name: 'theme-color',
      content: () => color.value
    }
  ],
  link: [
    { rel: 'icon', href: '/favicon.ico' }
  ],
  htmlAttrs: {
    lang: () => langCode.value
  }
})

const title = 'Trolleymate Insights'
const description = 'Trolleymate Insights description to be added here'

const isDegraded = computed(() => {
  return HealthCheckItem.value === null || !HealthCheckItem.value.insightsTimeScalesDatabaseUp || !HealthCheckItem.value?.insightsAppDatabaseUp
}
);

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: 'https://ui.nuxt.com/assets/templates/nuxt/dashboard-light.png',
  twitterImage: 'https://ui.nuxt.com/assets/templates/nuxt/dashboard-light.png',
  twitterCard: 'summary_large_image'
})

onMounted(() => {
  refresh()
})
</script>

<template>
  <UApp :locale="currentUiLocale">
  <div v-if="isDegraded"
    class="fixed inset-0 z-50 flex items-center justify-center bg-gray-950/80 backdrop-blur-sm p-4">
    <UContainer>
      <UCard>
        <template #header>
          <h2 class="text-xl font-semibold text-red-500">Service Alert</h2>
        </template>

        <p class="mb-4 text-gray-600 dark:text-gray-300">
          We are experiencing connectivity issues with our backend services.
          Automatic retries are in progress.
        </p>

        <div class="grid gap-2">
          <UBadge :color="HealthCheckItem?.insightsTimeScalesDatabaseUp ? 'success' : 'error'" variant="subtle">
            Insights Timescales DB: {{ HealthCheckItem?.insightsTimeScalesDatabaseUp ? 'Operational' : 'Down' }}
          </UBadge>
          <UBadge :color="HealthCheckItem?.insightsAppDatabaseUp ? 'success' : 'error'" variant="subtle">
            Insights App DB: {{ HealthCheckItem?.insightsAppDatabaseUp ? 'Operational' : 'Down' }}
          </UBadge>
        </div>
      </UCard>
    </UContainer>
  </div>

  <NuxtLoadingIndicator color="var(--color-trolleymate-500)" :height="6" :throttle="0" />

  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  </UApp>
</template>
